import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Components
import { ProceduresDebitComponent } from 'src/app/modules/procedures/views/procedures-debit/procedures-debit.component';
import { ProceduresNewComponent } from 'src/app/modules/procedures/views/procedures-new/procedures-new.component';
import { ProductsAddComponent } from 'src/app/modules/products/views/products-add/products-add.component';
import { ProductsDeleteComponent } from 'src/app/modules/products/views/products-delete/products-delete.component';
import { ProductsChangeComponent } from 'src/app/modules/products/views/products-change/products-change.component';

@Component({
  selector: 'app-procedures-buttons',
  templateUrl: './procedures-buttons.component.html',
  styleUrls: ['./procedures-buttons.component.scss']
})
export class ProceduresButtonsComponent implements OnInit {
  @Input() class: any;

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {

  }

  onDebitAdd(): void {
    this.dialog.open(ProceduresDebitComponent, {
      width: '400px',
    });
  }

  onComplaint(): void {
    window.open('https://www.iptel.com.ar/informar-clandestino', '_blank');
  }

  onProductSubscribe(): void {
    this.dialog.open(ProductsAddComponent, {
      width: '400px',
    });
  }

  onProductChange(): void {
    this.dialog.open(ProductsChangeComponent, {
      width: '400px',
    });
  }

  onProductUnsubscribe(): void {
    this.dialog.open(ProductsDeleteComponent, {
      width: '400px',
    });
  }

  onNewProcedure(): void {
    this.dialog.open(ProceduresNewComponent, {
      width: '400px'
    });
  }
}
